<!-- router-outlet *ngIf="!isSplash" [@fadeInOut]></router-outlet -->
<h1 class="visually-hidden">{{ pageName }}</h1>
<router-outlet></router-outlet>
